import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

export type ActionTriggerPayload = {
    action: string,
    params?: unknown
};

@Injectable({
    providedIn: 'root',
})
export class ActionTriggerService {
    constructor (
        private readonly monEventService: MonEventService,
    ) {}

    track (payload: ActionTriggerPayload): void {
        this.monEventService.run('actionTrigger', payload).catch();
    }
}
